module.exports = __webpack_public_path__ + "img/img@2x.bdebf4ff.png";